module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-SemiBold.woff?1d5bb5c64dc15405bdb04145dab7b436";